import {api} from "../../services";
import Swal from "sweetalert2";

const campaigns = {
  state: {
    data: [],
    pagination: [],
    metrics: [],
    templates_hsm: [],
    hsm_selected: {
      step: 1,
      data: {},
      history: {
        language: null,
        category: null,
        name: null,
        namespace: null,
        components: [
          {
            type: 'body',
            parameters: []
          }
        ],
      }
    },
    campaign: {},
    official_channel_id: null,
    board_view_enabled: false,
    modals: {
      initial_filter: false,
      view_campaign: false,
      confirm_delete_campaign: false,
      list_templates: false,
    },
    departments_available: [],
    users_available: [],
    fields_search: {
      channel_id: 0,
      user_id: 0,
      campaign_type: null,
      start_date: null,
      final_date: null
    },
    model_fields_search: {
      channel_id: 0,
      user_id: 0,
      campaign_type: null,
      start_date: null,
      final_date: null
    },
    infos: {},
    filter_campaigns_active: false,
  },
  getters: {
    getCampaignObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getCampaignsArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    // TODO: PENSAR EM UMA FORMA DE "COMPONENTIZAR" ESSA FUNÇÃO PRA FICAR DINÂMICA SEM PRECISAR FICAR COLOCANDO EM CADA MÓDULO.
    // SUGESTÃO:
    // CRIAR UMA FUNÇÃO COM O NOME: filterDepartmentsAvailable no módulo configs.js e na propriedade state, substituir por "rootState"
    // E SEMPRE PASSAR PARA ESSA FUNÇÃO QUAL store deve ser utilizado(activities, campaigns, etc...)
    filterDepartmentsAvailableOnCampaigns: (state) => (key, value) => {
      if (state.departments_available !== undefined) {
        return state.departments_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    filterUsersAvailableOnCampaigns: (state) => (key, value) => {
      if (state.users_available !== undefined) {
        return state.users_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
  },
  mutations: {
    SET_CAMPAIGNS_DATA(state, payload) {
      state.data = payload;
    },
    SET_CAMPAIGNS_PAGINATION(state, payload) {
      state.pagination = payload;
    },
    SET_CAMPAIGNS_METRICS(state, payload) {
      state.metrics = payload;
    },
    SET_CAMPAIGN(state, payload) {
      // this.dispatch("getCampaignsData", [payload.id]);
      state.campaign = payload
    },
    SET_CAMPAIGN_INFOS(state, payload) {
      state.infos = payload
    },
  },
  actions: {
    getCampaigns(context, fields_search) {
      api.get('/campaigns', { params: fields_search }).then(response => {
        context.commit("SET_CAMPAIGNS_DATA", response.data.data.data);
        context.commit("SET_CAMPAIGNS_PAGINATION", response.data.data);
        context.commit("SET_CAMPAIGNS_METRICS", response.data.metrics);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getCampaignsData(context, payload) {
      let ids = [];
      payload.forEach(p => {
        const item = context.state.data.find(i => {
          return p === i.channel_id
        });
        if (item === undefined) {
          ids.push(p);
        }
      });
      if (ids.length > 0) {
        api.post(`/campaigns`, {ids}).then(response => {
          context.commit("SET_CAMPAIGNS_DATA", response.data);
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      }
    },
    getCampaignsAll(context) {
      api.get(`/campaigns/all`).then(response => {
        context.commit("SET_CAMPAIGNS_DATA", response.data);
        context.commit("SET_CAMPAIGNS_PAGINATION", response.data.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Cards Info
    getCampaignsInfo(context, payload) {
      api.get('/campaigns/info', {
        params: payload
      }).then(response => {
        context.commit("SET_CAMPAIGN_INFOS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    stopCampaign(context, payload) {
      api.put(`/campaigns/stop-campaign/${payload.id}`).then((response) => {
        Swal.fire(
          `${context.rootGetters.getTranslations('expression_601')}`,
          `${context.rootGetters.getTranslations('expression_920')}`,
          'success'
        )
        this.dispatch('getCampaigns', context.state.fields_search)
        // this.dispatch('getCampaignsInfo', context.state.fields_search)
        $(`#showCampaign`).modal('hide')
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    playCampaign(context, payload) {
      api.put(`/campaigns/play-campaign/${payload.id}`).then((response) => {
        Swal.fire(
          `${context.rootGetters.getTranslations('expression_700')}`,
          `${context.rootGetters.getTranslations('expression_921')}`,
          'success'
        )
        this.dispatch('getCampaigns', context.state.fields_search)
        this.dispatch('getCampaignsInfo', context.state.fields_search)
        $(`#showCampaign`).modal('hide')
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    deleteCampaign(context, payload) {
      api.delete(`/campaigns/${payload.id}`).then(() => {
        Swal.fire(
          `${context.rootGetters.getTranslations('expression_908')}`,
          `${context.rootGetters.getTranslations('expression_909')}`,
          'success'
        )
        this.dispatch('getCampaigns', context.state.fields_search)
        this.dispatch('getCampaignsInfo', context.state.fields_search)
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    addCampaign(context, payload) {
      let return_fields_search = {
        channel_id: null,
        start_date: null,
        final_date: null
      }

      api.post(`/campaigns`, payload).then((response) => {
        this.dispatch('getCampaigns', return_fields_search)
        // this.dispatch('getCampaignsInfo', return_fields_search)
        context.state.filter_campaigns_active = true;
        context.state.board_view_enabled = true;

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: `${context.rootGetters.getTranslations('expression_910')}`,
          showConfirmButton: false,
          timer: 3500
        })

        setTimeout(() => {
          window.router.push({name: 'Campaigns'})
        }, 1500)
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire(
            `${context.rootGetters.getTranslations('expression_406')}`
              `${error.response.data.message}`,
            'warning'
          )
        }
      });
    }
  },
}
export default campaigns;
